/**
 * Returns whether the visual refresh mode is currently enabled.
 * @internal
 */
export function isVisualRefreshEnabled(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (globalThis as any).dtVisualRefreshEnabled === true;
}
